/**
 * Fonte única da paleta de prioridade/status, usada tanto pelas classes
 * Tailwind (priority-baixa/media/alta/urgente no tailwind.config.js) quanto
 * pelos componentes MUI (que não conseguem usar classes Tailwind custom via
 * a prop `color`). Antes, cada tela reimplementava sua própria escala de
 * cores (MUI success/warning/error, hex do Material Design, hex "flat
 * design" genérico) — a mesma prioridade tinha cores diferentes dependendo
 * da tela. Os valores aqui são os MESMOS hex das classes `priority-*`.
 */
export const CORES_PRIORIDADE = {
  baixa: '#0f9b8e',
  media: '#d68a1a',
  alta: '#e0611f',
  urgente: '#e10600',
} as const;

export const CORES_STATUS = {
  pendente: '#d68a1a',
  aIniciar: '#0277bd',
  emAndamento: '#8e44ad',
  aguardando: '#e0611f',
  concluida: '#0f9b8e',
  atrasada: '#e10600',
  arquivada: '#6b7280',
} as const;

export function obterCorPrioridade(prioridade: string): string {
  const chave = (prioridade || '').toLowerCase() as keyof typeof CORES_PRIORIDADE;
  return CORES_PRIORIDADE[chave] ?? CORES_PRIORIDADE.media;
}
